import React from 'react'
import MyAccount from './MyAccount';
import ClientProfile from './ClientProfile';
import useCurrentUser from 'hooks/useCurrentUser';
import Loader from 'components/Loader';
import { ToastContainer } from 'react-toastify';

const MyProfile = () => {
  const { user, loading } = useCurrentUser();
  if (loading) {
    return <Loader loading={loading} />
  }
  const { roleType } = user || {};

  return (
    <>
      {
        roleType === "PILOT" ? <MyAccount /> : <ClientProfile />
      }
      <ToastContainer />
    </>

  )
}

export default MyProfile